export default function Pill({ children, accent = false }) {
  const baseClasses = "font-mono text-[11px] tracking-wide uppercase py-2 px-2.5 rounded-full border whitespace-nowrap"
  const variantClasses = accent 
    ? "border-[rgba(122,215,255,0.28)] bg-accent-muted-dark text-text-dark"
    : "border-border-dark bg-white/[0.04] text-muted-dark"

  return (
    <div className={`${baseClasses} ${variantClasses}`}>
      {children}
    </div>
  )
}

